import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { map } from 'lodash';
import { Container, Stack } from '@lumahealthhq/ui-core';
import { ChipAvailability, ListAvailabilities, ListAvailabilitiesByFacility, ListAvailabilitiesByProvider } from './components';
import makeMockData from './utils/makeMockData';
import { jsx as _jsx } from "react/jsx-runtime";
var MOCK_DATA = makeMockData();
export default function FallbackContainerAvailabilitiesPicker(_ref) {
  var rest = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return /*#__PURE__*/_jsx(Container, _extends({
    maxWidth: false,
    disableGutters: true
  }, rest, {
    children: /*#__PURE__*/_jsx(Stack, {
      gap: 5,
      children: map(MOCK_DATA, function (groupByDate) {
        return /*#__PURE__*/_jsx(ListAvailabilities, {
          children: map(groupByDate.group, function (groupByFacility) {
            return /*#__PURE__*/_jsx(ListAvailabilitiesByFacility, {
              children: map(groupByFacility.group, function (groupByProvider) {
                return /*#__PURE__*/_jsx(ListAvailabilitiesByProvider, {
                  children: map(groupByProvider.availabilities, function (availability) {
                    return /*#__PURE__*/_jsx(ChipAvailability, {}, availability);
                  })
                }, groupByProvider.providerKey);
              })
            }, groupByFacility.facilityKey);
          })
        }, groupByDate.dateKey);
      })
    })
  }));
}